/* No scroll listeners, forced scrolling, gesture interception or dependencies. */
(() => {
  'use strict';
  window.AlphaWorksMobileFlow?.destroy();
  const root = document.documentElement;
  const phone = matchMedia('(max-width: 767px) and (min-height: 560px)');
  const sectionKinds = new Map([
    ['hero', 'intro'],
    ['aw-story-highlight', 'reading'],
    ['category-section', 'scene'],
    ['featured-section', 'reading'],
    ['lifestyle-pair', 'scene'],
    ['campaign-section', 'scene'],
    ['brand-note', 'bridge'],
    ['buying-guide-links', 'reading'],
  ]);
  const marked = new Map();
  let frame = 0;
  let main = null;
  let destroyed = false;

  function clear() {
    for (const [element, previous] of marked) {
      if (previous === null) element.removeAttribute('data-aw-flow-section');
      else element.setAttribute('data-aw-flow-section', previous);
    }
    marked.clear();
    resize.disconnect();
    root.classList.remove('aw-mobile-flow');
    root.removeAttribute('data-aw-flow-paused');
    for (const name of ['--aw-flow-header', '--aw-flow-intro', '--aw-flow-strip', '--aw-flow-band']) root.style.removeProperty(name);
  }

  function mark(element, kind) {
    if (!element) return;
    marked.set(element, element.getAttribute('data-aw-flow-section'));
    element.setAttribute('data-aw-flow-section', kind);
  }

  function measure() {
    if (!root.classList.contains('aw-mobile-flow')) return;
    const header = document.querySelector('.aw-header-section') || document.querySelector('.site-header');
    const hero = main?.querySelector('.hero');
    const strip = main?.querySelector('.sound-strip');
    const band = main?.querySelector('.red-band');
    if (!header || !hero) return;
    const style = getComputedStyle(header);
    const sticky = ['sticky', 'fixed'].includes(style.position);
    const inset = Math.max(0, parseFloat(style.top) || 0);
    const offset = sticky ? header.getBoundingClientRect().height + inset : 0;
    const intro = Math.max(0, hero.getBoundingClientRect().top + scrollY);
    const values = {
      '--aw-flow-header': offset,
      '--aw-flow-intro': intro,
      '--aw-flow-strip': strip?.getBoundingClientRect().height || 0,
      '--aw-flow-band': band?.getBoundingClientRect().height || 0,
    };
    for (const [name, number] of Object.entries(values)) {
      const value = `${Math.round(number * 100) / 100}px`;
      if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value);
    }
    if (window.visualViewport && visualViewport.scale > 1.05) root.setAttribute('data-aw-flow-paused', 'zoom');
    else root.removeAttribute('data-aw-flow-paused');
  }

  function scheduleMeasure() {
    if (destroyed || frame) return;
    frame = requestAnimationFrame(() => { frame = 0; measure(); });
  }

  const resize = new ResizeObserver(scheduleMeasure);

  function refresh() {
    if (destroyed) return;
    clear();
    main = document.querySelector('#main');
    const hero = main?.querySelector('.hero');
    const category = main?.querySelector('.category-section');
    if (window.awShopify?.designMode || !phone.matches || !hero || !category || main.querySelector('[data-aw-preview-active]')) return;
    for (const element of main.querySelectorAll([...sectionKinds.keys()].map(name=>'.'+name).join(','))) {
      for (const [className, kind] of sectionKinds) {
        if (element.classList.contains(className)) { mark(element, kind); break; }
      }
    }
    mark(document.querySelector('footer.site-footer'), 'reading');
    root.classList.add('aw-mobile-flow');
    for (const element of [document.querySelector('.aw-header-section') || document.querySelector('.site-header'), main.querySelector('.sound-strip'), main.querySelector('.red-band')]) {
      if (element) resize.observe(element);
    }
    measure();
  }

  const mutations = new MutationObserver(records => {
    const next = document.querySelector('#main');
    if (next !== main || records.some(record => record.target === main || record.target === document.body || record.target.classList?.contains('shopify-section'))) refresh();
  });

  function start() {
    if (destroyed) return;
    refresh();
    mutations.observe(document.body, { childList: true, subtree: true });
    document.fonts?.ready.then(scheduleMeasure);
  }

  phone.addEventListener('change', refresh);
  addEventListener('resize', scheduleMeasure, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleMeasure, { passive: true });
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });

  window.AlphaWorksMobileFlow = Object.freeze({
    refresh,
    destroy() {
      if (destroyed) return;
      destroyed = true;
      cancelAnimationFrame(frame);
      resize.disconnect();
      mutations.disconnect();
      clear();
      phone.removeEventListener('change', refresh);
      removeEventListener('resize', scheduleMeasure);
      window.visualViewport?.removeEventListener('resize', scheduleMeasure);
      document.removeEventListener('DOMContentLoaded', start);
    },
  });
})();
